import ApplicationController from './application_controller'


// Each select option tag should have a `data-section-selector` defined to match one or more  `section` targets.

export default class extends ApplicationController {

	static targets = [
		'section',
		'selectInput',
	]

	connect() {
		this.updateSections()
	}

	updateSections() {
		const selectedOption = this.selectInputTarget.options[this.selectInputTarget.selectedIndex] 
		const sectionToShow = selectedOption.dataset.sectionSelector

		this.sectionTargets.forEach( (sectionElement) => {
			if (sectionElement.matches(sectionToShow)) {
				this.showSection(sectionElement)
			} else {
				this.hideSection(sectionElement)
			}
		})
	}

	showSection(element) {
		element.classList.remove('d-none')
		element.querySelectorAll('input,select,textarea').forEach( (inputElement) => {
			inputElement.classList.remove('disabled')
			inputElement.removeAttribute('disabled')
		})
	}
	
	hideSection(element) {
		element.classList.add('d-none')
		element.querySelectorAll('input,select,textarea').forEach( (inputElement) => {
			inputElement.classList.add('disabled')
			inputElement.disabled = true
		})
	}

}

